var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apprentice-simple-card"},[_c('design-2021-apprentice-data-table',{attrs:{"items":_vm.payments,"fields":_vm.fields,"sort-compare":_vm.sortCompare},scopedSlots:_vm._u([{key:"cell(created_at)",fn:function(row){return [_vm._v(_vm._s(row.item.date))]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }